export class UnconveyancePropertyEditorResultDto {
    currentOwnerName: string;
    priorOwnerName: string;
    currentOwnerId: number;
    priorOwnerId: number;
    communityNamesCsv: string;
}
